import MarkdownIt from "markdown-it";
import 'highlight.js/styles/stackoverflow-light.css'
import hljs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript';

hljs.registerLanguage("js", javascript);

export function highlight(str, lang) {
    if (lang && hljs.getLanguage(lang)) {
        try {
            return hljs.highlight(lang, str).value;
        } catch (e) {
            //
        }
    }
    return '';
}

const markdownIt = new MarkdownIt({
    highlight,
});

export function renderMakrdown(md) {
    return markdownIt.render(md);
}

export function parseTaskMarkdown(md) {
    const tokens = markdownIt.parse(md);
    let title = "", status = [ "#" ];
    const top = () => status[status.length-1];
    const contentTokens = [];
    let initcode = "", inputs = [], judger = "";
    tokens.forEach((token) => {
        const { type, content, info } = token;
        if (type === 'heading_open') {
            status.push(type);
        } else if (type === 'heading_close') {
            status.pop();
        } else if (type === 'inline') {
            if (top() === 'heading_open') {
                title = content;
            } else if (top() === '#') {
                contentTokens.push(token);
            }
        } else
        if (type === 'fence') {
            const item = info.split(" ")[1];
            if (item === 'init') initcode = content;
            else if (item === 'input') inputs = eval(content);
            else if (item === 'judger') judger = content;
        } else {
            contentTokens.push(token);
        }
    });
    const content = markdownIt.renderer.render(contentTokens);
    return {
        title, content, initcode, inputs, judger
    }
}